import {
  trigger,
  transition,
  animate,
  keyframes,
  style,
  state
} from '@angular/animations';

export const tabStatus = trigger('tabStatus', [
  transition(
    '* => Traded',
    animate(
      3000,
      keyframes([
        style({
          opacity: 0,
          offset: 0
        }),
        style({
          opacity: 1,
          offset: 0.2
        }),
        style({
          opacity: 0,
          offset: 0.4
        }),
        style({
          opacity: 1,
          offset: 0.6
        }),
        style({
          opacity: 0,
          offset: 0.8
        }),
        style({
          opacity: 1,
          offset: 1
        })
      ])
    )
  )
]);

export const quoteActionAnimation = trigger('quoteActionAnimation', [
  transition(
    '* => ConfirmRFEAccept',
    animate(
      3000,
      keyframes([
        style({
          opacity: 0,
          offset: 0
        }),
        style({
          opacity: 1,
          offset: 0.2
        }),
        style({
          opacity: 0,
          offset: 0.4
        }),
        style({
          opacity: 1,
          offset: 0.6
        }),
        style({
          opacity: 0,
          offset: 0.8
        }),
        style({
          opacity: 1,
          offset: 1
        })
      ])
    )
  )
]);

export const pulseQuoteAnimation = trigger('quotePulse', [
  transition(
    '* <=> *',
    animate(
      '1500ms ease-in-out',
      keyframes([
        style({
          opacity: 0.5,
          offset: 0
        }),
        style({
          opacity: 1,
          offset: 0.33
        }),
        style({
          opacity: 0.5,
          offset: 0.66
        }),
        style({
          opacity: 1,
          offset: 1
        })
      ])
    )
  )
]);

export const pulseQuoteButtonAnimation = trigger('pulseQuoteButton', [
  transition(
    'false => true',
    animate(
      3000,
      keyframes([
        style({
          opacity: 0.7,
          offset: 0
        }),
        style({
          opacity: 1,
          offset: 0.26
        }),
        style({
          opacity: 0.6,
          offset: 0.52
        }),
        style({
          opacity: 1,
          offset: 0.78
        })
      ])
    )
  )
]);

export const fadeSlowAnimation = trigger('fadeSlow', [
  state('*', style({ opacity: 1 })),
  state('void', style({ opacity: 0 })),
  transition('void <=> *', [animate(`500ms ease-in-out`)])
]);

export const quoteEnterAnimation = trigger('quoteEnterAnimation', [
  transition(
    ':enter',
    animate(
      3000,
      keyframes([
        style({
          opacity: 0.8,
          offset: 0
        }),
        style({
          opacity: 1,
          offset: 0.26
        }),
        style({
          opacity: 0.8,
          offset: 0.52
        }),
        style({
          opacity: 1,
          offset: 0.78
        })
      ])
    )
  )
]);
